import { DefaultSeoProps } from "next-seo";

const seo: DefaultSeoProps = {
  title: "Fairlanes",
  description: "Sitio oficial de Fairlanes.",
  canonical: "https://funkyfairlanes.com/",
  openGraph: {
    url: "https://funkyfairlanes.com/",
    title: "Fairlanes",
    description: "Sitio oficial de Fairlanes.",
    type: "website",
    site_name: "fairlanes",
    images: [
      {
        url: "/img/share.jpg",
      },
    ],
  },
  additionalMetaTags: [
    {
      property: "mobile-web-app-capable",
      content: "yes",
    },
    {
      property: "apple-mobile-web-app-title",
      content: "Fairlanes",
    },
    {
      httpEquiv: "x-ua-compatible",
      content: "IE=edge; chrome=1",
    },
    {
      name: "viewport",
      content: "width=device-width, initial-scale=1, shrink-to-fit=no",
    },
  ],
  additionalLinkTags: [
    {
      rel: "icon",
      href: "/img/icons/96x96.png",
    },
    {
      rel: "apple-touch-icon",
      href: "/img/icons/180x180.png",
      sizes: "180x180",
    },
    {
      rel: "manifest",
      href: "/manifest.json",
    },
  ],
};

export default seo;
